var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 9.1665V4.99984C3.66675 4.11578 4.01794 3.26794 4.64306 2.64281C5.26818 2.01769 6.11603 1.6665 7.00008 1.6665C7.88414 1.6665 8.73198 2.01769 9.3571 2.64281C9.98222 3.26794 10.3334 4.11578 10.3334 4.99984M2.83341 9.1665H11.1667C12.0872 9.1665 12.8334 9.9127 12.8334 10.8332V15.8332C12.8334 16.7536 12.0872 17.4998 11.1667 17.4998H2.83341C1.91294 17.4998 1.16675 16.7536 1.16675 15.8332V10.8332C1.16675 9.9127 1.91294 9.1665 2.83341 9.1665ZM7.83341 13.3332C7.83341 13.7934 7.46032 14.1665 7.00008 14.1665C6.53984 14.1665 6.16675 13.7934 6.16675 13.3332C6.16675 12.8729 6.53984 12.4998 7.00008 12.4998C7.46032 12.4998 7.83341 12.8729 7.83341 13.3332Z",
    stroke: "#4D5A81",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenGroup);
export default __webpack_public_path__ + "static/media/open-group.c5a40c17d87e5261ddd149a88f29be64.svg";
export { ForwardRef as ReactComponent };